import { InjectionKey, Ref } from "vue";

export interface OperatingDaysResponseDto {
    /**
     * Day in ISO format, e.g. 2022-01-02
     */
    calendarDate: string;
    operatingSchedules: OperatingDayScheduleDto[];
    featuredSchedules: FeaturedDayScheduleDto[];
}

export interface OperatingDayScheduleDto {
    extCalendarId: string;
    isClosed: boolean;
    isAllDay: boolean;
    isTbd: boolean;
    closedToPublic: boolean;
    from: string | null;
    to: string | null;
}

export interface FeaturedDayScheduleDto {
    extCalendarId: string;
    operatingExtCalendarId: string;
    isAllDay: boolean;
    isTbd: boolean;
    from?: string;
    to?: string;
    prependText?: string;
    appendText?: string;
}

export interface ActivityDayScheduleDto {
    extCalendarId: string;
    operatingExtCalendarId: string;
    schedules: TimeSlotDto[];
    isAllDayEvent: boolean;
    toBeDetermined: boolean;
}

export interface TimeSlotDto {
    displayStart: string;
    displayEnd?: string;
    sortKey?: number; // effectively TimeOfDay.TotalSeconds
    prependText?: string;
    appendText?: string;
}

export interface ActivityTimeModel {
    sortKey: string;
    activity: ActivityDayScheduleDto;
    schedule: TimeSlotDto | undefined;
}

export const Event = {
    ActivitySelected: 'activitySelected',
    DataLoaded: 'dataLoaded'
};

export const FilteredExtCalendarId: InjectionKey<Ref<string | null>> = Symbol();

